import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import Button from '../../components/Button';
import { PaymentIcon } from '../../components/Icons';

export default function AdminPayments() {
  const [tickets, setTickets] = useState([]);
  const [comments, setComments] = useState({});

  const load = () => api.get('/api/admin/tickets').then((r) => setTickets(r.data.filter((t) => t.payment_status === 'open' && t.status === 'pending_payment')));
  useEffect(() => { load(); }, []);

  const action = async (id, endpoint) => {
    try { await api.post(`/api/admin/tickets/${id}/${endpoint}`, { admin_comment: comments[id] || '' }); load(); }
    catch (err) { alert(err.response?.data?.detail || 'Fehler'); }
  };

  return (
    <div>
      <h2 className="page-title">Offene Zahlungen</h2>
      {tickets.length === 0 ? (
        <div className="card text-center py-12">
          <div className="flex justify-center mb-3">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-sm">
              <PaymentIcon className="w-6 h-6 text-white" />
            </div>
          </div>
          <p className="text-emerald-600 font-semibold">Keine offenen Zahlungen</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tickets.map((t) => (
            <div key={t.id} className="card border-l-4 border-l-sand-400">
              <div className="flex flex-wrap justify-between gap-2 mb-3">
                <div>
                  <p className="font-mono font-bold text-ocean-800">#{t.ticket_code}</p>
                  <p className="text-sm text-slate-600">{t.buyer?.firstname} {t.buyer?.lastname}</p>
                  {t.price && <p className="text-sm font-bold text-sand-700">{parseFloat(t.price).toFixed(2)} €</p>}
                  {t.payment_reference && (
                    <p className="text-sm mt-1 font-medium text-slate-700">
                      <svg className="inline w-3.5 h-3.5 mr-1 text-slate-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 12.5l-9.5 9.5a6 6 0 0 1-8.5-8.5l10-10a4 4 0 0 1 5.5 5.5L9 18.5a2 2 0 0 1-3-3l8.5-8.5"/>
                      </svg>
                      Referenz: <span className="text-ocean-700">{t.payment_reference}</span>
                    </p>
                  )}
                </div>
                <span className="text-xs font-semibold bg-sand-100 text-sand-700 border border-sand-200 px-2.5 py-0.5 rounded-full h-fit">Ausstehend</span>
              </div>
              <div className="flex gap-2 flex-wrap items-center">
                <input className="input text-xs flex-1 min-w-40" placeholder="Kommentar (optional)"
                  value={comments[t.id] || ''} onChange={(e) => setComments({ ...comments, [t.id]: e.target.value })} />
                <Button variant="success" size="sm" onClick={() => action(t.id, 'confirm-payment')}>✓ Zahlung bestätigen</Button>
                <Button variant="danger" size="sm" onClick={() => action(t.id, 'reject-payment')}>✗ Ablehnen</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
